<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isSysAdmin()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div
                                    class="col-sm-3"
                                    v-if="
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Branch:</span
                                        >
                                        <v-select
                                            v-model="params.branch"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-3"
                                    v-if="
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by User ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            style="width: 100% !important"
                                            v-model="params.appuser"
                                            type="text"
                                            placeholder="Enter User ID"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-sm-3"
                                    v-if="
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Mobile Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            style="width: 100% !important"
                                            v-model="params.mobile"
                                            type="text"
                                            placeholder="Enter User ID"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="From Date"
                                            v-model="params.fromdate"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="To Date"
                                            v-model="params.todate"
                                        />
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="getRequests()"
                                        >
                                            Generate
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!--                        <div class="row">-->
                            <!--                            -->
                            <!--                        </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        Discount Requests
                        <!--						<button class="btn btn-danger float-right">Add Discount</button>-->
                        <button
                            class="btn btn-danger float-right"
                            @click="getRequests()"
                        >
                            Refresh
                        </button>
                    </div>
                    <div class="card-body overflow-auto">
                        <!-- content here -->
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Item Code</th>
                                    <th scope="col">Customer</th>
                                    <th scope="col">MOP</th>
                                    <th scope="col">Requested Discount</th>
                                    <th scope="col">Requestor</th>
                                    <th scope="col">Approved Discount</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="req in requests">
                                    <td>{{ req.branch_code }}</td>
                                    <td>{{ req.created_at | timeStamp }}</td>
                                    <td>
                                        <p>{{ req.item_name }}</p>
                                        <p>
                                            {{ req.item_code }} &nbsp;
                                            &nbsp;<span
                                                class="badge badge-secondary"
                                                @click="
                                                    SAPItemCodeSearch(
                                                        req.item_code
                                                    )
                                                "
                                                ><i class="fa fa-search"></i
                                                >Pricelist</span
                                            >
                                        </p>
                                    </td>
                                    <td v-if="req.lead_profile != null">
                                        {{ req.lead_profile.name }},
                                        {{ req.lead_profile.mobile }}
                                    </td>
                                    <td v-if="req.lead_profile == null">
                                        {{ req.cust_name }},
                                        {{ req.cust_code }}
                                    </td>
                                    <td>{{ req.item_mop }}</td>
                                    <td>{{ req.requested_discount_amount }}</td>
                                    <td>
                                        <p>
                                            Requested by: &nbsp;
                                            {{ req.creator.user_detail }}
                                        </p>
                                        <p v-if="req.updator != null">
                                            Approved by: &nbsp;
                                            {{ req.updator.user_detail }}
                                        </p>
                                    </td>
                                    <td>{{ req.approved_discount_amount }}</td>
                                    <td
                                        v-if="req.status == 'New'"
                                        class="badge-warning"
                                    >
                                        {{ req.status }}
                                    </td>
                                    <td
                                        v-if="req.status == 'Approved'"
                                        class="badge-success"
                                    >
                                        {{ req.status }}
                                    </td>
                                    <td
                                        v-if="req.status == 'Rejected'"
                                        class="badge-danger"
                                    >
                                        {{ req.status }}
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-secondary"
                                            @click="edit(req)"
                                        >
                                            Decide
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getRequests(pagination.prevPageUrl)"
                            @next="getRequests(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="icantthinkofaname"
            aria-hidden="true"
            id="icantthinkofaname"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">
                            Pick Item
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <table class="table table-striped table-hover">
                                <thead
                                    class="thead-dark"
                                    style="position: sticky; top: 0"
                                >
                                    <tr>
                                        <th class="header" scope="col">
                                            Item Code
                                        </th>
                                        <th class="header" scope="col">
                                            Item Name
                                        </th>
                                        <th class="header" scope="col">
                                            Price List
                                        </th>
                                        <th class="header" scope="col">
                                            TaxRate
                                        </th>
                                        <th class="header" scope="col">
                                            Price
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="i in SAPItems">
                                        <th scope="row">{{ i.ItemCode }}</th>
                                        <th scope="row">{{ i.ItemName }}</th>
                                        <th scope="row">
                                            {{ i.PriceListName }}
                                        </th>
                                        <td>{{ i.TaxRate }}</td>
                                        <td>
                                            <p>{{ i.Price }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="discountModal"
            aria-hidden="true"
            id="discountModal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">Manage Discount</div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Customer Phone:</label>
                            <input
                                class="form-control"
                                v-model="form.mobile"
                                type="number"
                                placeholder="Enter the customer number"
                                min="1000000000"
                            />
                        </div>
                        <!--    		<div class="form-group">-->
                        <!--    			<button class="btn btn-primary" @click="searchCus">Search Customer</button>-->
                        <!--    		</div>-->
                        <!--    		<div class="form-group">-->
                        <!--    			<label>Customer Name</label>-->
                        <!--    			<input class="form-control" v-model="form.name" type="text" disabled>-->
                        <!--    		</div>-->
                        <div class="form-group">
                            <label>Item Code</label>
                            <input
                                class="form-control"
                                v-model="form.item_code"
                                type="text"
                                disabled
                            />
                        </div>
                        <div class="form-group">
                            <label>Item Name</label>
                            <input
                                class="form-control"
                                v-model="form.item_name"
                                type="text"
                                disabled
                            />
                        </div>
                        <div class="form-group">
                            <label>Item MOP</label>
                            <input
                                class="form-control"
                                v-model="form.item_mop"
                                type="text"
                                disabled
                            />
                        </div>
                        <div class="form-group">
                            <label>Discount Amount:</label>
                            <input
                                class="form-control"
                                v-model="form.requested_discount_amount"
                                type="number"
                                placeholder="Enter the discount amount"
                                min="1"
                                step="0.01"
                            />
                        </div>
                        <div class="form-group">
                            <label>Remarks</label>
                            <input
                                class="form-control"
                                v-model="form.remarks"
                                type="text"
                                disabled
                            />
                        </div>
                        <div
                            v-if="
                                $gate.isMISAdmin() ||
                                $gate.isSecondaryMISAdmin()
                            "
                            class="row"
                        >
                            <div class="col-md-5">
                                <div class="form-group">
                                    <button
                                        class="btn btn-success"
                                        style="width: 100%"
                                        @click="accept"
                                    >
                                        Accept
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100%"
                                        @click="deny"
                                    >
                                        Deny
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isSysAdmin()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination, loading },

    created() {
        this.getBranches();
        this.getRequests();
        this.pollData();
    },

    data() {
        return {
            requests: [],
            errors: [],
            results: "",
            params: new Form({
                from_date: null,
                to_date: null,
                branch: null,
                appuser: null,
            }),
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            form: new Form({
                mobile: "",
                name: "",
                item_code: "",
                item_name: "",
                remarks: "",
                item_mop: "",
                lead_profile_id: "",
                requested_discount_amount: "",
                id: "",
            }),
            customer_phone: "",
            customer_name: "",
            search_status: "",
            lshow: "",
            llabel: "Please Wait...",
            interval: null,
            branch: "",
            branches: [],
            code: "",
        };
    },

    methods: {
        pollData() {
            this.interval = setInterval(() => {
                this.getRequests();
            }, 150000);
        },

        reset() {
            this.fromdate = "";
            this.todate = "";
            this.branch = "";
            this.appuser = "";
            this.params.reset();
            this.getBranches();
            this.getStats();
        },
        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getRequests(url = "/api/getPendingDiscountRequests") {
            axios
                .post(url, { results: this.results, params: this.params })
                .then((response) => {
                    this.requests = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        showPriceList(code) {
            this.code = code;
            $("#icantthinkofaname").modal("show");
        },

        SAPItemCodeSearch(code) {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            this.lshow = true;
            this.llabel = this.search_status;
            axios
                .post("/api/SAPPriceList", { code: code })
                .then((response) => {
                    if (response.data != 0) {
                        this.SAPItems = response.data;
                        toast.fire({
                            icon: "success",
                            title: "Search Complete",
                        });
                        $("#icantthinkofaname").modal("show");
                    } else
                        toast.fire({
                            icon: "success",
                            title: "No Items",
                        });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                })
                .catch((error) => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        edit(req) {
            this.form.fill(req);
            $("#discountModal").modal("show");
        },

        accept() {
            this.lshow = true;
            axios
                .post("/api/acceptDiscount", {
                    id: this.form.id,
                    amount: this.form.requested_discount_amount,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Discount Approved",
                    });
                    this.getRequests(
                        "/api/getDiscountRequests" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                });
            this.lshow = false;
        },

        deny() {
            this.lshow = true;
            axios.post("/api/denyDiscount", { id: this.form.id }).then(() => {
                toast.fire({
                    icon: "success",
                    title: "Discount Denied",
                });
                this.getRequests(
                    "/api/getDiscountRequests" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
            this.lshow = false;
        },
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
